module.exports = __webpack_public_path__ + "media/vid_phone_case4.3b965dc0.mp4";